import { CSSProperties } from 'react'
import { IconWait } from '../img'

const StepUsedCarFileFinish = () => {

    const style: CSSProperties = {
        display: 'flex',
        justifyContent: 'center'
    }


    return <>
        <div className='mt-40 mb-40' style={style}>
            < IconWait />
        </div>
        <label style={{ ...style, textAlign: 'center', fontSize: '20px', color: '#008866', lineHeight: '30px' }}>Esta a un paso de su <br></br> nueva póliza</label>
        <p style={{ ...style, textAlign: 'center', fontSize: '15px', color: '#4D4D4D', lineHeight: '22px' }}>
            Un ejecutivo de Seguros LAFISE se  <br></br> comunicará con usted lo antes posible  <br></br> para evaluación y finalización de su  <br></br> compra.

        </p>
    </>
}

export { StepUsedCarFileFinish }